import { DEFAULT_GRADIENTS } from '../components/GradientManager/configuration/constants';

export const componentsSettings = {
  DEFAULT_GRADIENTS,
};
